import React from "react";
import { kinetik_api_url} from "~/app/utilities";
import axios from 'axios';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FontAwesome from 'react-fontawesome';
import _ from 'underscore';
import {addViewBatches,setStatusCardIndex} from '../status_card_view/actions'

class StatusRejectedToolbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          batches:null,
          rejected_count:0,
        };
      }

  componentWillMount=()=>{
    const token = localStorage.getItem('authToken');
    const bill_npi = localStorage.getItem('bill_npi');
    console.log("bill_npi",bill_npi);
    axios.get(kinetik_api_url+"/batch/rejected?bill_npi="+bill_npi+"&token="+token).then((res)=>{
        console.log("rejected claims",res)
        let rejected_count=0;
        _.each(res.data,batch=>{
            rejected_count+=batch.rejected_count.length;
        })
        this.setState({batches:res.data,rejected_count:rejected_count});
        console.log("rejected count",rejected_count);
    })
  }
  setView_RejectedBatches=()=>{
      if(this.state.batches!==null){
        const batches = Object.assign({},this.state.batches);
        this.props.addViewBatches(batches);
      }

  }
    setView_LatestBatches=()=>{
      const bill_npi= localStorage.getItem('bill_npi');
      const token = localStorage.getItem('authToken');
      axios
        .get(kinetik_api_url + "/batch/recent/"+bill_npi+"?token="+token)
        .then(response => {
          this.props.addViewBatches(response.data);
        })
        .catch(err => {
          console.log("/batch error:", err);
        });
    }

  render() {

    return (
           <div className="rejected-status-box">
            {
                (this.state.batches!==null)&&
                <div>
                {/* <FontAwesome className="back-icon" name="arrow-left" onClick={this.setView_LatestBatches} /> */}
                <span className="line-height-2_1"><span className="red">{this.state.rejected_count}</span> Claims need correction</span>
                <button className="btn btn-primary submit-btn right" onClick={this.setView_RejectedBatches}>
                    View Batches with Rejected Claims
                </button>
                </div>
            }
           </div>
    );
  }
}

const mapStateToProps = state => {
    return {
    };
  };
  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        addViewBatches,setStatusCardIndex
      },
      dispatch
    );
  }
  

export default connect(mapStateToProps, mapDispatchToProps)(StatusRejectedToolbar);





// WEBPACK FOOTER //
// ./src/app/batch_status/status_rejected_toolbar/Status_Rejected_Toolbar.js